import React from "react";
import { AwardIcon, HandshakeIcon, SparklesIcon, TruckIcon, EarIcon, CompassIcon, ClipboardListIcon, LifeBuoyIcon, HeartIcon, ShieldCheckIcon, WalletIcon, BoxIcon } from "lucide-react";
const ICONS: Record<string, BoxIcon> = {
  award: AwardIcon,
  handshake: HandshakeIcon,
  sparkles: SparklesIcon,
  truck: TruckIcon,
  ear: EarIcon,
  compass: CompassIcon,
  clipboard: ClipboardListIcon,
  lifebuoy: LifeBuoyIcon,
  heart: HeartIcon,
  shield: ShieldCheckIcon,
  wallet: WalletIcon
};
type IconProps = {
  name: string;
  className?: string;
  strokeWidth?: number;
};
export function Icon({
  name,
  className = 'h-6 w-6',
  strokeWidth = 1.5
}: IconProps) {
  const Component = ICONS[name] ?? SparklesIcon;
  return <Component className={className} strokeWidth={strokeWidth} aria-hidden="true" data-id="element-263" data-mp="2udx2lbznhv5n" />;
}